export function byEndsAt({ asc = true } = {}) {
  return ({ endsAt: a }, { endsAt: b }) => {
    if (new Date(a) > new Date(b)) return asc ? 1 : -1
    if (new Date(a) < new Date(b)) return asc ? -1 : 1
    return 0
  }
}

export function byLevels({ country = '', asc = true } = {}) {
  return ({ qualification: a }, { qualification: b }) => {
    if (
      a &&
      a.levels &&
      a.levels.some(l => l.countryCode == country) &&
      b &&
      b.levels &&
      b.levels.some(l => l.countryCode == country)
    ) {
      if (asc) {
        return (
          a.levels.find(l => l.countryCode == country).value -
          b.levels.find(l => l.countryCode == country).value
        )
      }
      return (
        b.levels.find(l => l.countryCode == country).value -
        a.levels.find(l => l.countryCode == country).value
      )
    }
    if (a && a.levels && a.levels.some(l => l.countryCode == country)) return asc ? 1 : -1
    if (b && b.levels && b.levels.some(l => l.countryCode == country)) return asc ? -1 : 1
    return 0
  }
}

export default {
  byEndsAt,
  byLevels
}
